import moment from "moment-timezone";
import { call, put, select } from "redux-saga/effects";

import { setTimezone } from "../reducers/account/accountActions.js";

import accountSelectors from "../reducers/account/accountSelectors.js";

// -- SAGAS -- //

// set the default moment timezone based on current account values
export function* setDefaultMomentTimezoneSaga() {
  const timezoneName = yield select(accountSelectors.selectTimezoneName);
  if (timezoneName) moment.tz.setDefault(timezoneName);
  return timezoneName;
}

export function* applyTimezoneSaga(timezoneId) {
  // if an account timezone isn't set use a best guess
  if (typeof timezoneId !== "string") {
    const state = yield select();
    const guess = moment.tz.guess();

    const timezoneEntity = state.timezones.data.find(item => {
      return item.value === guess;
    });

    const timezone =
      typeof timezoneEntity === "object" ? timezoneEntity["@id"] : undefined;

    yield put(setTimezone(timezone));
  }

  yield call(setDefaultMomentTimezoneSaga);
}
